<template>
    <div v-prefix v-clicked-outside="() => { focus_search(false) }" class="#player-search flex flex-column relative">
        <ul v-show="value.length" class="reset">
            <li v-prefix v-for="player in value" :key="player.id" class="#player-search__list-item border-light-a">
                <icon-wrapper icon="sf-minus-minimal">
                    <button 
                        v-prefix
                        @click="remove_player_from_filter(player.id)" 
                        :aria-label="`Remove ${player.text} from search filters`" 
                        class="#player-search__list-item-btn reset flex flex-align-center w-100 text-left" 
                        type="button"
                    >
                        <span v-prefix class="#player-search__list-item-image-container flex-item-auto mr-1 rounded overflow-hidden block">
                            <img :src="`${player.image_path}?width=36&height=36&mode=crop`" :alt="`${player.text}'s Headshot`" />
                        </span>

                        <span class="flex-item-1">{{ player.text }}</span>
                    </button>
                </icon-wrapper>
            </li>
        </ul>

        <icon-wrapper 
            :class="{ 
                'is-focused': search_focused, }" 
                :icon="search_focused ? 'sf-search-2' : 'sf-plus-minimal'" 
                size="1.5rem"
            >
            <input 
                @focus="focus_search" 
                v-model="search_keyword" 
                :placeholder="search_focused ? 'Type to search players' : 'Select a Player'" 
                type="text" 
                class="sidearm-galleries-input" 
                ref="search" 
            />
        </icon-wrapper>

        <div v-prefix :class="{ 'is-toggled': search_focused }" class="#player-search__dropdown bg-white">
            <ul v-prefix class="#player-search__dropdown-list reset">
                <li v-prefix  v-for="player in filtered_search_results" :key="player.id" class="#player-search__dropdown-list-item">
                    <button 
                        v-prefix 
                        @click="add_player_to_filter(player)" 
                        :aria-label="`Add ${player.text} to search filters`" 
                        class="#player-search__dropdown-list-btn reset flex flex-align-center w-100 text-left" 
                        type="button"
                    >
                        <span v-prefix class="#player-search__dropdown-list-item-image-container flex-item-auto mr-1 rounded overflow-hidden block">
                            <img :src="`${player.image_path}?width=36&height=36&mode=crop`" :alt="`${player.text}'s Headshot`" />
                        </span>

                        <span class="flex-item-1">{{ player.text }}</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import debounce from 'lodash-es/debounce'

    export default {
        props: {
            value: {
                type: Array,
                required: true,
                default: () => ([])
            }
        },

        data: () => ({
            player_popover_open: false,

            search_focused: false,

            search_keyword: '',

            search_results: [],
        }),

        computed: {
            filtered_search_results() {
                return this.search_results.filter(player => this.value.every(p => p.id !== player.id)).slice(0,5);
            },
        },

        watch: {
            search_keyword(newVal, oldVal) {
                if (newVal && newVal.length >= 3) {
                    this.search_players();
                }
            }
        },

        methods: {
            toggle_player_popover(value) {
                if (value !== undefined) {
                    this.player_popover_open = !!value;
                }
                else {
                    this.player_popover_open = !this.player_popover_open;
                }

                if (this.player_popover_open === true) {
                    this.$refs.search.focus();
                }
            },

            focus_search(value = true) {
                if (value === false) {
                    this.search_results = [];
                    this.search_keyword = '';
                }

                this.search_focused = value;
            },

            close_player_popover() {
               
            },

            search_players: debounce(function() {
                api.search_players(this.search_keyword)
                    .then(players => {
                        this.search_results = players;
                    });
            }, 600),

            add_player_to_filter(player) {
                this.$nextTick(() => {
                    this.search_focused = true;
                });

                let updated_players = this.value.slice();

                updated_players.push(player);

                this.$emit('input', updated_players);
            },

            remove_player_from_filter(player_id) {
                let updated_players = this.value.slice();

                updated_players = updated_players.filter(player => player.id !== player_id);

                this.$emit('input', updated_players);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .#{$prefix}__player-search {
        &__list-item { 
            margin-bottom: -1px;
        }

        &__list-item, &__dropdown-list-item {
            transition: .35s;

            &:hover {
                background-color: $color-primary;
                color: $text-on-primary;
            }
        }

        &__list-item-image-container, &__dropdown-list-item-image-container {
            background: $color-primary url('/images/logos/site/site.png?width=36&height=36&mode=crop') center center;
            background-size: contain;
            height: 36px;
            width: 36px;
        }

        &__list-item-btn {
            padding: $spacer !important;
        }

        &__dropdown {
            @include hide();
            box-shadow: 0px 1px $spacer rgba($color-black, 0.08);

            &.is-toggled {
                @include unhide();

                position: absolute;
                top: 100%;
                left: 0;
                width: 100%;
            }
        }

        &__dropdown-list-item {
            &:not(:last-child) {
                border-bottom: 1px solid $stroke-on-light;
            }
        }

        &__dropdown-list-btn {
            padding: $spacer !important;
        }
    }
</style>